import styled from "styled-components";

/**
 * Shared container for consistent alert spacing across all alert types.
 * Provides uniform padding to maintain visual consistency.
 */
export const StyledContainerAlert = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`;
